import Service from "./service";
import {
  REGISTRATION_BP_ASSIGNED, REGISTRATION_CANCELLED,
  REGISTRATION_PENDING_CONFIRMATION, REGISTRATION_PENDING_PDTC_PROCESSING,
  REGISTRATION_REJECTED,
  TRANSFER_COMPLETED
} from "../helpr/constants";

class SecondaryMarketService extends Service {

  constructor(unauthorized=false) {
    super("SECONDARY_MARKET_SERVICE", unauthorized);
  }

  //Investor Registrations
  createRegistration = (registrationObj) => {
    let formattedObj = {
      ...registrationObj,
      faceAmount: parseFloat(registrationObj.faceAmount.replaceAll(',',''))
    }
    return this.post(`/registrations`, {}, formattedObj);
  }

  getListOfRegistrations = () => {
    return this.get(`/registrations`);
  }

  getRegistration = registrationId => {
    return this.get(`/registrations/${registrationId}`);
  }

  submitRegistration = (registrationId, registrationObj) => {
    let formattedObj = {
      ...registrationObj,
      faceAmount: parseFloat(registrationObj.faceAmount.replaceAll(',',''))
    }
    return this.patch(`/registrations/${registrationId}/submit`, {}, formattedObj);
  }

  confirmRegistration = (registrationId, registrationObj) => {
    let formattedObj = {
      ...registrationObj,
      faceAmount: parseFloat(registrationObj.faceAmount.replaceAll(',','')),
      registrationStatus: REGISTRATION_PENDING_PDTC_PROCESSING
    }
    return this.patch(`/registrations/${registrationId}/confirm`, {}, formattedObj);
  }

  cancelRegistration = (registrationId, registrationObj) => {
    let formattedObj = {
      ...registrationObj,
      faceAmount: parseFloat(registrationObj.faceAmount.replaceAll(',','')),
      registrationStatus: REGISTRATION_CANCELLED
    }
    return this.patch(`/registrations/${registrationId}/confirm`, {}, formattedObj);
  }

  completeRegistration = (registrationId, registrationObj) => {
    let formattedObj = {
      ...registrationObj,
      faceAmount: parseFloat(registrationObj.faceAmount.replaceAll(',','')),
      registrationStatus: REGISTRATION_BP_ASSIGNED
    }
    return this.patch(`/registrations/${registrationId}/administer`, {}, formattedObj);
  }

  rejectRegistration = (registrationId, data) => {
    return this.patch(`/registrations/${registrationId}/administer`, {}, {
      ...data,
      registrationStatus: REGISTRATION_REJECTED
    });
  }

  //Transfers
  createTransfer = (transferObj) => {
    return this.post(`/transfers`, {}, transferObj);
  }

  getListOfTransfers = () => {
    return this.get(`/transfers`);
  }

  getTransfer = transferId => {
    return this.get(`/transfers/${transferId}`);
  }

  submitTransfer = (transferId, transferObj) => {
    let formattedObj = {
      ...transferObj,
      transferAmount: parseFloat(transferObj.transferAmount.replaceAll(',',''))
    }
    return this.patch(`/transfers/${transferId}/submit`, {}, formattedObj);
  }

  confirmTransfer = (transferId, transferObj) => {
    return this.patch(`/transfers/${transferId}/confirm`, {}, transferObj);
  }

  completeTransfer = transferId => {
    return this.patch(`/transfers/${transferId}/administer`, {}, {
      transferStatus: TRANSFER_COMPLETED
    });
  }

  rejectTransfer = (transferId, data, status) => {
    return this.patch(`/transfers/${transferId}/administer`, {}, {
      ...data,
      transferStatus: status
    });
  }
}

export default SecondaryMarketService;
